/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, gender: "f" | "m" }} Selected_CountInputs */



/**
* | gender | selectedCountPlural | output |
* | --- | --- | --- |
* | "f" | "one" | "{count} selected" |
* | "f" | "other" | "{count} selected" |
* | "f" | "zero" | "None selected" |
* | "m" | "one" | "{count} selected" |
* | "m" | "other" | "{count} selected" |
* | "m" | "zero" | "None selected" |
*
* @param {Selected_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const selected_count = /** @type {((inputs: Selected_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const selectedCountPlural = registry.plural("en", i?.count, {}, true);
		if (i?.gender === "f" && selectedCountPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} selected`);
		if (i?.gender === "f" && selectedCountPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} selected`);
		if (i?.gender === "f" && selectedCountPlural === "zero") return /** @type {LocalizedString} */ (`None selected`);
		if (i?.gender === "m" && selectedCountPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} selected`);
		if (i?.gender === "m" && selectedCountPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} selected`);
		if (i?.gender === "m" && selectedCountPlural === "zero") return /** @type {LocalizedString} */ (`None selected`);
		return /** @type {LocalizedString} */ ("selected_count");
	}
	{
		const selectedCountPlural = registry.plural("fr", i?.count, {}, true);
		if (i?.gender === "f" && selectedCountPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} sélectionnée`);
		if (i?.gender === "f" && selectedCountPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} sélectionnées`);
		if (i?.gender === "f" && selectedCountPlural === "zero") return /** @type {LocalizedString} */ (`Aucune sélectionnée`);
		if (i?.gender === "m" && selectedCountPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} sélectionné`);
		if (i?.gender === "m" && selectedCountPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} sélectionnés`);
		if (i?.gender === "m" && selectedCountPlural === "zero") return /** @type {LocalizedString} */ (`Aucun sélectionné`);
		return /** @type {LocalizedString} */ ("selected_count");
	}
});